// const validateNationalIdFunc = (nationalId) => {
//   let yy = 0;
//   let yv = 0;
//   yv = parseInt(yv);
//   let isValid;

import normalizeDate from "../date/normalizeDate";

//   for (let i = 0; i < nationalId.length; i++) {
//     yv = nationalId[i] * (nationalId.length - i);
//     yy += yv;
//   }
//   let x = yy % 11;

//   if (x === 0) {
//     isValid = true;
//   } else {
//     isValid = false;
//   }
//   yy = 0;
//   return isValid;
// };
const correctObj = { isValid: true, msg: "" };
export function validateNationalIdFunc(nationalID) {
  // Must be exactly 10 digits
  if (!/^\d{10}$/.test(nationalID)) {
    return false;
  }

  // Reject repeated digit codes (e.g., 0000000000, 1111111111, ...)
  const repeatedDigits = [
    "0000000000",
    "1111111111",
    "2222222222",
    "3333333333",
    "4444444444",
    "5555555555",
    "6666666666",
    "7777777777",
    "8888888888",
    "9999999999",
  ];
  if (repeatedDigits.includes(nationalID)) {
    return false;
  }

  // Checksum calculation
  let total = 0;
  for (let i = 0; i < 9; i++) {
    total += parseInt(nationalID[i], 10) * (10 - i);
  }

  const lastDigit = parseInt(nationalID[9], 10);
  const remainder = total % 11;

  return (remainder < 2 && remainder === lastDigit) || (remainder >= 2 && 11 - remainder === lastDigit);
}
const validate = ({
  data,
  type,
  length,
  certainDate,
  forceLtr,
  checkArrayOfObjectKeyNames,
  isOptional,
  inWhichStateOrderItBecomesNecessary,
  clickedActionOrder,
}) => {
  let properData;
  let returnedValidityObject;
  if (data === null || data === undefined) {
    properData = "";
  } else if (typeof data === "string") {
    properData = data;
  } else if (typeof data === "number") {
    properData = data.toString();
  } else if (typeof data === "object") {
    properData = data?.id;
  } else if (typeof data === "boolean") {
    properData = "true";
  }
  if (inWhichStateOrderItBecomesNecessary) {
    if (clickedActionOrder) {
      if (inWhichStateOrderItBecomesNecessary <= clickedActionOrder) {
        return validate({ data, type, length, certainDate, forceLtr, isOptional: false });
      } else {
        return validate({ data, type, length, certainDate, forceLtr, isOptional: true });
      }
    } else {
      returnedValidityObject = {
        isValid: false,
        msg: [
          "There are no clickedActionOrder while there is a inWhichStateOrderItBecomesNecessary (report this to PNG)",
        ],
      };
    }
  } else {
    if (isOptional && properData?.trim() === "") {
      returnedValidityObject = { isValid: true, msg: "" };
    } else if (isOptional && !type) {
      returnedValidityObject = { isValid: true, msg: "" };
    } else if (!isOptional && !properData) {
      returnedValidityObject = {
        isValid: false,
        msg: forceLtr ? ["This field is mandatory"] : ["MANDATORY"],
      };
    } else {
      if (type === "mandatory" || (!isOptional && !type)) {
        returnedValidityObject =
          !properData || (typeof properData === "string" ? properData?.trim() === "" : null)
            ? {
                isValid: false,
                msg: forceLtr ? ["This field is mandatory"] : ["MANDATORY"],
              }
            : { isValid: true, msg: "" };
      } else if (type === "definedLength") {
        returnedValidityObject =
          properData?.length === length
            ? { isValid: true, msg: "" }
            : {
                isValid: false,
                msg: forceLtr ? [`Must be ${length} digits`] : ["MUST_BE", length, "DIGITS"],
              };
      } else if (type === "nationalCode" || type === "NationalCode") {
        if (properData.length === 10) {
          let isValid = validateNationalIdFunc(properData);
          returnedValidityObject = isValid
            ? { isValid: true, msg: "" }
            : {
                isValid: false,
                msg: forceLtr ? ["National code is not valid"] : ["NATIONALCODE_IS_NOT_VALID"],
              };
        } else {
          returnedValidityObject = {
            isValid: false,
            msg: forceLtr ? ["Must be 10 digits"] : ["MUST_BE", "10", "DIGITS"],
          };
        }
      } else if (type === "insuranceCode" || type === "InsuranceCode") {
        console.log("data", data);
        console.log("properData", properData);
        if (properData.length === 10) {
          returnedValidityObject =
            properData.substring(0, 2) === "00"
              ? { isValid: true, msg: "" }
              : {
                  isValid: false,
                  msg: forceLtr ? ["Insurance code is not valid"] : ["INSURANCE_CODE_IS_NOT_VALID"],
                };
        } else {
          returnedValidityObject = {
            isValid: false,
            msg: forceLtr ? ["Must be 10 digits"] : ["MUST_BE", "10", "DIGITS"],
          };
        }
      } else if (type === "beforePeresentTime") {
        const wrongObj = {
          isValid: false,
          msg: forceLtr ? [`Must be before today`] : ["MUST_BE_BEFORE_TODAY"],
        };
        const inputDate = normalizeDate(data);
        if (inputDate) {
          // const compareDate = new Date(inputDate);
          // compareDate.setHours(0, 0, 0, 0);
          const today = new Date();
          // today.setHours(0, 0, 0, 0);
          returnedValidityObject = inputDate < today ? correctObj : wrongObj;
        }
      } else if (type === "afterPeresentTime") {
        const wrongObj = {
          isValid: false,
          msg: forceLtr ? ["Must be after today"] : ["MUST_BE_AFTER_TODAY"],
        };
        const inputDate = normalizeDate(data);
        if (inputDate) {
          // const compareDate = new Date(inputDate);
          // compareDate.setHours(0, 0, 0, 0);
          const today = new Date();
          // today.setHours(0, 0, 0, 0);
          returnedValidityObject = inputDate > today ? correctObj : wrongObj;
        }
      } else if (
        type === "phoneNumber" ||
        type === "cellphone" ||
        type === "Cellphone" ||
        type === "mobileNumber" ||
        type === "Phone"
      ) {
        if (
          properData.length === 11 ||
          (properData.length === 12 && properData.startsWith("98")) ||
          (properData.length === 13 && properData.startsWith("+98"))
        ) {
          let numRegex = new RegExp("^(\\+98|0)?9\\d{9}$");
          let phoneIsValid = numRegex.test(properData);
          if (phoneIsValid) {
            returnedValidityObject = { isValid: true, msg: "" };
          } else {
            returnedValidityObject = {
              isValid: false,
              msg: forceLtr ? ["Phone number is not valid"] : ["PHONE_NUMBER_IS_NOT_VALID"],
            };
          }
        } else {
          returnedValidityObject = {
            isValid: false,
            msg: forceLtr ? [`Must be 11 digits`] : ["MUST_BE", "11", "DIGITS"],
          };
        }
      } else if (type === "email" || type === "Email") {
        let numRegex = new RegExp(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        );
        let phoneIsValid = numRegex.test(properData);
        if (phoneIsValid) {
          returnedValidityObject = { isValid: true, msg: "" };
        } else {
          returnedValidityObject = {
            isValid: false,
            msg: forceLtr ? ["Email is not valid"] : ["EMAIL_IS_NOT_VALID"],
          };
        }
      } else if (type === "JustNumbers") {
        const justNumberRegex = /^\d+$/; // Matches one or more digits
        let phoneIsValid = justNumberRegex.test(properData.replace(/,/g, ""));
        if (phoneIsValid) {
          returnedValidityObject = { isValid: true, msg: "" };
        } else {
          returnedValidityObject = {
            isValid: false,
            msg: forceLtr ? ["Only numbers are valid"] : ["ONLY_NUMBERS_ARE_VALID"],
          };
        }
      } else if (type === "JustDecimalNumbers") {
        const justDecimalRegex = /^\d+(\.\d+)?$/;
        let decimalIsValid = justDecimalRegex.test(properData.replace(/,/g, ""));
        if (decimalIsValid) {
          returnedValidityObject = { isValid: true, msg: "" };
        } else {
          returnedValidityObject = {
            isValid: false,
            msg: forceLtr ? ["Only decimal numbers are valid"] : ["ONLY_DECIMAL_NUMBERS_ARE_VALID"],
          };
        }
      } else if (type === "JustAlphabet") {
        const justNumberRegex = /^[\p{L} ]+$/u; // Matches one or more digits
        let phoneIsValid = justNumberRegex.test(properData);
        if (phoneIsValid) {
          returnedValidityObject = { isValid: true, msg: "" };
        } else {
          returnedValidityObject = {
            isValid: false,
            msg: forceLtr ? ["Only alphabets are valid"] : ["ONLY_ALPHABETS_ARE_VALID"],
          };
        }
      } else if (type === "postalCode" || type === "PostalCode") {
        if (properData.length === 10) {
          let postalCodeRegex = new RegExp(/\b(?!(d)\1{3})[13-9]{4}[1346-9][013-9]{5}\b/);
          let postalCodeIsValid = postalCodeRegex.test(properData);
          if (postalCodeIsValid) {
            returnedValidityObject = { isValid: true, msg: "" };
          } else {
            returnedValidityObject = {
              isValid: false,
              msg: forceLtr ? ["Postal code is not valid"] : ["POSTALCODE_NOT_VALID"],
            };
          }
        } else {
          returnedValidityObject = {
            isValid: false,
            msg: forceLtr ? ["Postal dode must be 10 digits"] : ["POSTALCODE_MUST_BE_10_DIGITS"],
          };
        }
      } else if (type === "afterCertainDate") {
        const wrongObj = {
          isValid: false,
          msg: forceLtr
            ? [`Must be after ${certainDate.label}`]
            : ["MUST_BE_AFTER", certainDate.label, "BASHAD"],
        };
        const inputDate = normalizeDate(data);
        const compareDate = normalizeDate(certainDate?.value);
        if (inputDate && compareDate) {
          // const compareDate = new Date(inputDate);
          // compareDate.setHours(0, 0, 0, 0);

          // compareDate.setHours(0, 0, 0, 0);
          returnedValidityObject = inputDate > compareDate ? correctObj : wrongObj;
        }
      } else if (type === "beforeCertainDate") {
        const wrongObj = {
          isValid: false,
          msg: forceLtr
            ? [`Must be before ${certainDate.label}`]
            : ["MUST_BE_BEFORE", certainDate.label, "BASHAD"],
        };
        const inputDate = normalizeDate(data);
        const compareDate = normalizeDate(certainDate?.value);
        if (inputDate && compareDate) {
          // const compareDate = new Date(inputDate);
          // compareDate.setHours(0, 0, 0, 0);

          // compareDate.setHours(0, 0, 0, 0);
          returnedValidityObject = inputDate < compareDate ? correctObj : wrongObj;
        }
      } else if (type === "suggestion") {
        if (data === "notFromOptions") {
          returnedValidityObject = {
            isValid: false,
            msg: forceLtr ? ["Must be choosen from options"] : ["MUST_BE_FROM_OPTIONS"],
          };
        } else if (data) {
          returnedValidityObject = { isValid: true, msg: "" };
        } else if (!data && !isOptional) {
          returnedValidityObject = {
            isValid: false,
            msg: forceLtr ? ["This field is mandatory!"] : ["MANDATORY"],
          };
        }
      } else if (type === "securedPassword") {
        if (properData?.trim() === "") {
          returnedValidityObject = {
            isValid: false,
            msg: forceLtr ? ["This field is mandatory!"] : "thisFieldIsMandatory",
          };
        } else {
          if (properData?.length < 10) {
            returnedValidityObject = {
              isValid: false,
              msg: forceLtr
                ? [`Must be at least 10 digits`]
                : ["MUST_BE", "atLeast", "10", "DIGITS", "bashad"],
            };
          } else {
            const noSpaces = !/\s/.test(properData);
            if (!noSpaces) {
              returnedValidityObject = {
                isValid: false,
                msg: forceLtr ? ["Do not use space"] : "spaceIsNotAllowed",
              };
            } else {
              const hasUppercase = /[A-Z]/.test(properData); // At least one uppercase letter
              if (!hasUppercase) {
                returnedValidityObject = {
                  isValid: false,
                  msg: forceLtr ? ["Must include an uppercase"] : "mustIncludeAUppercase",
                };
              } else {
                const hasLowercase = /[a-z]/.test(properData); // At least one lowercase letter
                if (!hasLowercase) {
                  returnedValidityObject = {
                    isValid: false,
                    msg: forceLtr ? ["Must include a lowercase"] : "mustIncludeALowercase",
                  };
                } else {
                  const hasNumber = /\d/.test(properData); // At least one number
                  if (!hasNumber) {
                    returnedValidityObject = {
                      isValid: false,
                      msg: forceLtr ? ["Must include a number"] : "mustIncludeANumber",
                    };
                  } else {
                    const hasValidSpecialChar = /[@#$%^]/.test(properData); // At least one valid special character
                    if (!hasValidSpecialChar) {
                      returnedValidityObject = {
                        isValid: false,
                        msg: forceLtr
                          ? ["Must include special character"]
                          : "mustContainSpecialCharacters",
                      };
                    } else {
                      const onlyEnglishAlphabets = /^[A-Za-z\d@#$%^]*$/.test(properData); // Restricts to English alphabets, digits, and allowed special chars
                      if (!onlyEnglishAlphabets) {
                        returnedValidityObject = {
                          isValid: false,
                          msg: forceLtr ? ["Use only english alphabets"] : "englishAlphabetsAreAllowed",
                        };
                      } else {
                        returnedValidityObject = { isValid: true, msg: "" };
                      }
                    }
                  }
                }
              }
            }
          }
        }
      } else if (type === "username") {
        if (!properData?.trim()) {
          returnedValidityObject = {
            isValid: false,
            msg: forceLtr ? "This field is mandatory" : "thisFieldIsMandatory",
          };
        } else if (/\s/.test(properData)) {
          returnedValidityObject = {
            isValid: false,
            msg: forceLtr ? "Username cannot contain spaces." : "spaceIsNotAllowed",
          };
        } else if (/[^a-zA-Z0-9]/.test(properData.replace(/[_\.]/g, ""))) {
          returnedValidityObject = {
            isValid: false,
            msg: forceLtr
              ? "Username can be English alphabets and numbers."
              : "englishAndNumberIsAllowed",
          };
        } else if (/[^a-zA-Z0-9_.]/.test(properData)) {
          returnedValidityObject = {
            isValid: false,
            msg: forceLtr ? "only _ and . is allowed." : "onlyDotUnderScoreIsAllowed",
          };
        } else {
          returnedValidityObject = { isValid: true, msg: "" };
        }
      } else {
        console.log(`saye alert : type is not defined in validationV2,png says type is ${type}`);
        returnedValidityObject = { isValid: true, msg: "" };
      }
    }
    if (type === "atLeastOneItem") {
      if (data && Array.isArray(data) && data[0]) {
        const filteredArrayOfItems = data.filter((eachData) => {
          let returnedValue = true;
          for (const eachKeName of checkArrayOfObjectKeyNames) {
            if (
              (Object.prototype.toString.call(eachData?.[eachKeName]) === "[object Object]" &&
                !eachData?.[eachKeName]?.id) ||
              !eachData?.[eachKeName]
            ) {
              returnedValue = false;
              break;
            }
          }
          return returnedValue;
        });
        if (filteredArrayOfItems.length > 0) {
          returnedValidityObject = { isValid: true, msg: "" };
        } else {
          returnedValidityObject = {
            isValid: false,
            msg: forceLtr ? ["Add at least one correct item"] : ["ADD_ONCE_CORRECT_ITEM_AT_LEAST"],
          };
        }
      } else {
        returnedValidityObject = {
          isValid: false,
          msg: forceLtr ? ["Add at least one item"] : ["ADD_ONCE_ITEM_AT_LEAST"],
        };
      }
    } else if (type === "atLeastOneItemEvenEmpty") {
      if (data && Array.isArray(data) && data[0]) {
        returnedValidityObject = { isValid: true, msg: "" };
      } else {
        returnedValidityObject = {
          isValid: false,
          msg: forceLtr ? ["Add at least one item"] : ["ADD_ONCE_ITEM_AT_LEAST"],
        };
      }
    }
  }

  return returnedValidityObject;
};

export default validate;
// "":"","":"","":"","":"","":"","":"","":"","":"","":"","":"","":"","":"","":"","":"","":"","":"","":"",,
